export enum ChangeDocumentStatus {
    rename = 'reanme',
    copy = 'copy'
}
